import React, { createContext, useState, useContext } from 'react';

const PopupContext = createContext();
export const usePopup = () => useContext(PopupContext);

export const PopupProvider = ({ children }) => {
  const [popup, setPopup] = useState({ message: '', visible: false });
  const [confirm, setConfirm] = useState({ message: '', visible: false, onConfirm: null, onCancel: null });

  const showPopup = (message, duration = 5000) => {
    setPopup({ message, visible: true });
    setTimeout(() => {
      setPopup({ message: '', visible: false });
    }, duration);
  };

  const showConfirm = (message) => {
    return new Promise((resolve) => {
      setConfirm({
        message,
        visible: true,
        onConfirm: () => {
          setConfirm({ ...confirm, visible: false });
          resolve(true);
        },
        onCancel: () => {
          setConfirm({ ...confirm, visible: false });
          resolve(false);
        }
      });
    });
  };

  return (
    <PopupContext.Provider value={{ showPopup, showConfirm }}>
      {children}

      {/* Toast-style popup - Optimized for both mobile and desktop */}
      {popup.visible && (
        <div className="fixed z-[9999] w-full flex justify-center px-4
                      top-4 animate-fade-in-down 
                      md:top-auto md:bottom-5 md:animate-fade-in-up">
          <div className="bg-gray-800 text-white px-4 py-3 rounded-lg shadow-xl 
                         max-w-full md:max-w-md w-full text-center">
            <span className="text-sm font-medium">{popup.message}</span>
          </div>
        </div>
      )}

      {/* Confirmation Dialog (unchanged) */}
      {confirm.visible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-white p-6 rounded-xl shadow-2xl max-w-md w-full mx-4 border border-gray-100">
            <p className="text-gray-800 text-lg font-medium mb-6 text-center">{confirm.message}</p>
            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <button
                onClick={confirm.onCancel}
                className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirm.onConfirm}
                className="px-5 py-2.5 rounded-lg bg-purple-600 text-white font-medium hover:bg-purple-700 transition-colors"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </PopupContext.Provider>
  );
};
// src/context/PopupContext.js
// import React, { createContext, useState, useContext } from 'react';

// const PopupContext = createContext();
// export const usePopup = () => useContext(PopupContext);

// export const PopupProvider = ({ children }) => {
//   const [popup, setPopup] = useState({ message: '', visible: false });
//   const [confirm, setConfirm] = useState({ message: '', visible: false, onConfirm: null, onCancel: null });

//   const showPopup = (message, duration = 3000) => {
//     setPopup({ message, visible: true });
//     setTimeout(() => {
//       setPopup({ message: '', visible: false });
//     }, duration);
//   };

//   const showConfirm = (message) => {
//     return new Promise((resolve) => {
//       setConfirm({
//         message,
//         visible: true,
//         onConfirm: () => {
//           setConfirm({ ...confirm, visible: false });
//           resolve(true);
//         },
//         onCancel: () => {
//           setConfirm({ ...confirm, visible: false });
//           resolve(false);
//         }
//       });
//     });
//   };

//   return (
//     <PopupContext.Provider value={{ showPopup, showConfirm }}>
//       {children}

//       {/* Toast-style popup */}
//       {popup.visible && (
//         <div className="fixed bottom-5 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-6 py-3 rounded-lg shadow-xl z-[9999] animate-fade-in-up">
//           <div className="flex items-center justify-center space-x-2">
//             <span className="text-sm font-medium">{popup.message}</span>
//           </div>
//         </div>
//       )}

//       {/* Confirmation Dialog */}
//       {confirm.visible && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 animate-fade-in">
//           <div className="bg-white p-6 rounded-xl shadow-2xl max-w-md w-full mx-4 border border-gray-100 transform transition-all duration-200 scale-100">
//             <p className="text-gray-800 text-lg font-medium mb-6 text-center">{confirm.message}</p>
//             <div className="flex flex-col sm:flex-row justify-center gap-3">
//               <button
//                 onClick={confirm.onCancel}
//                 className="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirm.onConfirm}
//                 className="px-5 py-2.5 rounded-lg bg-purple-600 text-white font-medium hover:bg-purple-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
//               >
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </PopupContext.Provider>
//   );
// };
